
import './grey-box.css';

export default function GreyBoxComponent({ children, className = "" }) {
    return (
        <div className={`grey-box ${className}`}>
            {children}
        </div>
    );
}